<script setup>
import {computed} from 'vue'

import Button from "@/common/Button.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const pageContentId = computed(() => pageEditorStore.activePageContentId)
const pageContent = computed(() => pageEditorStore.contentItems.find(o => o.pageContentId === pageContentId.value))
const isHeaderOrFooterContent = computed(() => pageContent.value?.contentAreaName === 'Page header'
    || pageContent.value?.contentAreaName === 'Page footer')

const moveUp = () => {
    pageEditorStore.moveUp(pageContentId.value)
}
</script>

<template>
    <Button v-if="!isHeaderOrFooterContent" @click="moveUp" class="btn-sm d-flex align-items-center gap-2">
        <i class="bi bi-chevron-up"></i>
        Move up
    </Button>
</template>